import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase/FirebaseCredential";

interface PermissionState {
  permissions: Record<string, any>;
  loading: boolean;
}

const initialState: PermissionState = {
  permissions: {},
  loading: true,
};

// Async action to fetch permissions from Firestore
export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (roleId : string ) => {
    const permissionsRef = collection(db, "defaultsystempermissions");
    const q = query(permissionsRef, where("role_type", "==", roleId));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      throw new Error("No permissions found for this role and role type");
    }

    const permissionMap: Record<string, any> = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      // console.log(data, "defaultsystempermissions");
      permissionMap[data.resource_id] = {
        create: data.create ?? false,
        read: data.read ?? false,
        update: data.update ?? false,
        delete: data.delete ?? false,
        role_type: data.role_type ?? "",
      };
    });

    // console.log(permissionMap, "fetchPermissions");

    return permissionMap;
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload;
        state.loading = false;
      })
      .addCase(fetchPermissions.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default permissionsSlice.reducer;
